import { Logo } from "@paribus/shared-ui";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface AuthLayoutProps {
  children: ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="flex min-h-screen flex-col bg-primary-subtle font-sans text-foreground">
      <div className="flex flex-1">
        {/* Left side: Decorative/Branding - Sticky for desktop */}
        <div className="relative sticky top-0 hidden h-screen items-center justify-center overflow-hidden lg:flex lg:w-1/2">
          <div className="relative z-10 px-12 text-center">
            <Link
              to="/"
              className="group mb-8 inline-flex cursor-pointer flex-col items-center justify-center transition-all hover:opacity-90 active:scale-press"
            >
              <div className="mb-6 inline-flex items-center justify-center rounded-2xl border border-primary-border bg-card p-4 shadow-xl transition-all group-hover:bg-card/80">
                <Logo variant="mark" size="xl" disableLink />
              </div>
              <h2 className="mb-2 text-4xl font-bold leading-tight tracking-tight text-foreground">
                Welcome to <span className="text-primary">Paribus AI</span>
              </h2>
            </Link>
            <p className="mx-auto max-w-md text-xl leading-relaxed text-muted-foreground">
              The next generation of AI-powered analysis and insights for professionals.
            </p>
          </div>
        </div>

        {/* Right side: Auth Form */}
        <div className="flex w-full items-center justify-center p-8 lg:w-1/2">
          <div className="w-full max-w-md">
            <div className="mb-12 flex flex-col items-center lg:hidden">
              <Link
                to="/"
                className="flex cursor-pointer flex-col items-center transition-all hover:opacity-80"
              >
                <Logo variant="stacked" size="lg" disableLink />
              </Link>
            </div>

            <div className="rounded-2xl border border-border-subtle bg-card p-10 shadow-xl">
              {children}
            </div>

            <p className="mt-8 text-center text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} Paribus AI. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
